import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'companyid-not-found',
    templateUrl: './not-found.component.html',
    styleUrl: './not-found.component.scss',
    imports: [NgOptimizedImage, AssetPipe, RouterLink],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {
    @HostBinding('class')
    public readonly hostClassname = 'py-120px flex flex-col gap-60px items-center mob:px-5 mob:pt-120px mob:pb-80px';
}
